<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="标题" prop="name">
                <el-input v-model="form.name" placeholder="请输入标题" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="封面" prop="cover">
                <Uploader v-model="form.cover"></Uploader>
            </el-form-item>
            <el-form-item label="详情" prop="detail">
                <Editor v-model="form.detail"></Editor>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" type="primary" @click="handleConfirm">确定</el-button>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import Uploader from "@/components/Uploader";
import Editor from "@/components/Editor";
import { add, edit, detail } from "@/api/content/story";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Language, Uploader, Editor },
    data() {
        return {
            form: {
                keyword: "",
                lang: "zh",
            },
            rules: {
                name: [{ required: true, message: "请输入标题" }],
                cover: [{ required: true, message: "请上传封面" }],
                detail: [{ required: true, message: "请输入详情" }],
            },
            isEdit: false,
            cuuid: "",
            add: true,
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        if (this.form.cuuid) {
            this.add = false;
            this.isEdit = true;
            this.getDetail();
        } else {
            this.add = true;
            this.form.cuuid = getUuid();
        }
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                        this.cuuid = result.cuuid;
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid };
                        this.cuuid = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                };
                if (this.isEdit) {
                    if (this.cuuid) {
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("修改成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("添加成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
